import { Box, Typography } from "@mui/material";

import { ProjectPp } from "api/memberPortal/project/protectionProfiles/protectionProfile.types";
import { usePpDropdownOptionsQuery } from "api/memberPortal/project/protectionProfiles/protectionProfiles.api";
import { AppFormType } from "components/Forms/AppForm";
import { optionAlphaSort } from "utils/sort";

import { protectionProfilesRequiringSbom } from "../Schemas/SubSchemas/ProtectionProfiles.schema";

interface PPSectionProps {
  productForm: AppFormType | { AppField: any };
  productPps: ProjectPp[];
}

const PPSection = ({ productForm, productPps }: PPSectionProps) => {
  const { data: allPps = [] } = usePpDropdownOptionsQuery();

  const ppOptions = allPps
    .filter(
      (pp) =>
        !productPps?.some(
          (productPp) => productPp.product__product_id === pp.value,
        ),
    )
    .sort(optionAlphaSort);

  /* WARN: Custom styling from pre standardization! */
  /* TODO: Standardize when you come across this!  */

  const sbomLabel = (
    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
      Per Policy Letter #30, all evaluations submitted to NIAP for evaluation
      claiming conformance against the AppSW PP or the AppSW cPP will be
      required to include an SBOM. By checking this box, you are confirming that
      the required SBOM has been emailed to{" "}
      <Box component="span" sx={{ textDecoration: "underline" }}>
        NIAP-SBOM@niap-ccevs.org
      </Box>{" "}
      prior to submittal of this form
    </Typography>
  );

  return (
    <Box className="mb-4">
      {/* WARN: Custom styling from pre standardization! */}
      {/* TODO: Standardize when you come across this!  */}
      <Typography variant="body1" className="mb-2">
        PROTECTION PROFILE CLAIMS
      </Typography>
      <div className="border p-3 rounded">
        {/* WARN: Custom styling from pre standardization! */}
        {/* TODO: Standardize when you come across this!  */}
        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          Select the Protection Profile Claims for this product.
        </Typography>
        <productForm.AppField name="protectionProfiles.protection_profile">
          {(field: any) => (
            <field.MultiAutocompleteSelect
              options={ppOptions}
              label="Protection Profile Claims:"
              size="small"
              data-cy="protection-profile-select"
              required
            />
          )}
        </productForm.AppField>

        <productForm.AppField name="protectionProfiles.protection_profile">
          {(field: any) => {
            const currentPpValues = field.state.value || [];
            const sbomPpSelected = currentPpValues.some((id: any) => {
              return protectionProfilesRequiringSbom.includes(id.label);
            });

            if (sbomPpSelected) {
              return (
                <Box sx={{ mt: 3 }}>
                  <productForm.AppField name="protectionProfiles.sbom_submitted">
                    {(sbomField: any) => (
                      <sbomField.SingleCheckbox label={sbomLabel} />
                    )}
                  </productForm.AppField>
                </Box>
              );
            }
            return null;
          }}
        </productForm.AppField>
      </div>
    </Box>
  );
};

export default PPSection;
